import React from 'react';
import styled from 'styled-components';
import {
  attachLocale,
  attachShopSlug,
  makeExternalUrl,
  resolveAccessibleLabel
} from '../../../../lib/utils';
import { DATA_TRACK_TYPE_INTERNAL } from '../../../../lib/constants';
import Button from '../Button/Button';
import {
  getBrowseCategoriesLevelThreeAnalytics,
  getShopImageAnalyticsSlug,
} from '../NavigationCategoriesBar/levelThreeBrowseCategoriesAnalytics';

const ShopImgDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${p => p.theme.unit(18)}; 
  height: ${p => p.theme.unit(9)};
  background-color: ${p => p.theme.c.bg.primary};
  margin: ${p => p.theme.unit(1.5)};
  padding: ${p => p.theme.unit(1)};
  border: 1px solid ${p => p.theme.c.border.primary};
`;

const ShopImg = styled.img`
  max-width: ${p => p.theme.unit(18)}; 
  max-height: ${p => p.theme.unit(9)};
`;

const ShopImgContainerDiv = styled(Button)`
  cursor: pointer;
`;

const InvisibleDiv = styled.div`
  width: ${p => p.theme.unit(18)}; 
  height: ${p => p.theme.unit(9)};
  margin: ${p => p.theme.unit(1.5)};
  padding: ${p => p.theme.unit(1)};
`;

const ShopsGridDiv = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  padding: ${p => p.theme.unit(2)} 0;
`;

const ShopsGrid = (props) => {
  const {
    shops = [],
    locale = 'en',
    parentCategoryAnalyticsSlug = '',
  } = props;

  const isOdd = (n) => {
    return n % 2;
  };

  // Limit to 4 shops
  const renderShops = shops.slice(0, 4);

  const shopsImages = renderShops.map((s) => {
    if (!s) {
      return null;
    }

    const {
      mediumImageUrl = '',
      mediumImageAltText = '',
      slug = '',
      linkTextPrepositions,
      config = {}
    } = s;

    const { secondaryText } = config;

    const storeInfoLabel = resolveAccessibleLabel(
      null,
      s,
      linkTextPrepositions,
      'for',
      secondaryText,
    );

    const resolvedImageUrl = makeExternalUrl(mediumImageUrl);
    let shopLink = attachShopSlug(slug);
    shopLink = attachLocale(shopLink, locale);

    const track = getBrowseCategoriesLevelThreeAnalytics({
      analyticsSlug: getShopImageAnalyticsSlug(slug),
      parentCategoryAnalyticsSlug,
      url: shopLink,
    });

    return (
      <ShopImgContainerDiv
        variant="tertiary"
        accessibleLabel={storeInfoLabel}
        key={slug}
        shopSlug={slug}
        dataTrackType={DATA_TRACK_TYPE_INTERNAL}
        {...track}
      >
        <ShopImgDiv>
          <ShopImg
            src={resolvedImageUrl}
            alt={mediumImageAltText} />
        </ShopImgDiv>
      </ShopImgContainerDiv>
    );
  });

  // Fill with blank data to align images to the left
  if (isOdd(shopsImages.length)) {
    shopsImages.push(<InvisibleDiv key="blank-shop" />);
  }

  return (
    <ShopsGridDiv>
      {shopsImages}
    </ShopsGridDiv>
  );
};

export default ShopsGrid;
